import { createFileRoute } from "@tanstack/react-router";
import { Dashboard } from "../app/views/dashboard/dashboard";

export const Route = createFileRoute("/dashboard")({
  component: Dashboard,
});
